<template>
  <div>
    <validation-observer
      id="register-form"
      ref="register-form"
      tag="form"
      @submit.prevent
    >
      <div class="content">
        <h2
          v-if="screen==='profile'"
          class="is-title is-size-5"
        >
          Your login.phila.gov account information
        </h2>
        <div
          v-if="$route.query.incomplete === 'true'"
          class="notification is-success has-icon m-b-md"
        >
          <p>
            <span class="icon">
              <i class="fas fa-check-circle" />
            </span>
            Your <strong>login.phila.gov</strong> account has been created. You can use this account to sign in to participating City of Philadelphia websites. Please continue to complete your profile for this application.
          </p>
        </div>
        <p>Name: <span class="has-text-weight-bold">{{ `${$store.state.auth.account.firstName} ${$store.state.auth.account.lastName}` }}</span></p>
        <p v-if="emailFromToken">
          Email: <span class="has-text-weight-bold">{{ emailFromToken }}</span>
        </p>
        <p>
          To reset your password, <a
            class="has-text-weight-bold"
            herf="#"
            @click.prevent="$store.dispatch('phillyAccount/msalForgotPassword');"
          >click here</a>.
        </p>
      </div>
      <!-- <div class="field is-grouped">
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.firstName"
            rules="required"
            :placeholder="$wording.register.text_1"
            name="firstName"
            required
          />
        </div>
        <div class="control middle-name is-expanded">
          <textbox
            v-model="form.middleName"
            :placeholder="$wording.register.text_13"
            name="middleName"
          />
        </div>
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.lastName"
            rules="required"
            :placeholder="$wording.register.text_2"
            name="lastName"
            required
          />
        </div>
      </div> -->
      <hr class="is-darker">

      <div class="content">
        <h3
          class="is-title is-size-5"
        >
          {{ $route.query.incomplete === 'true' ? 'Complete your profile for the Lead Certification Submission System' : 'Update your information for the Lead Certification Submission System' }}
        </h3>
        <p v-if="$route.query.incomplete === 'true'">
          This application has requested more information from you. You must provide a mailing address to finish creating your Lead Certification Submission System profile.
        </p>
        <p v-else>
          This application stores additional information in your profile. You can update your profile below.
        </p>
        <p>
          This information will not be used for any purposes unrelated to this application. <a
            href="#"
            @click.prevent="showTermsAndConditions"
          >Learn more about data privacy</a>.
        </p>
      </div>

      <div class="content">
        <h4 class="is-size-6 has-text-weight-semibold">
          Contact information
        </h4>
      </div>
      <div
        v-if="screen === 'register'"
        class="field is-grouped"
      >
        <div class="control is-expanded">
          <input-text-with-validation
            v-model.trim="form.email"
            rules="required|email"
            placeholder="Email"
            name="email"
            required
          />
        </div>
      </div>
      <div class="field is-grouped field-grouped-half-fix">
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.phoneNumber"
            :placeholder="$wording.register.text_3"
            name="phoneNumber"
            :rules="(form.contactPreference === 'phone') ? 'required' : ''"
          />
        </div>
        <div class="control is-expanded">
          <dropdown
            v-model="form.contactPreference"
            :default-option="$wording.register.text_4"
            name="contactPreference"
            :options="{ 'email': 'Email', 'mail': 'Physical mail', 'phone': 'By phone' }"
          />
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.companyName"
            name="company"
            :placeholder="$wording.register.text_5"
          />
        </div>
        <div class="control is-expanded">
          <textbox
            v-model="form.jobTitle"
            name="jobTitle"
            :placeholder="$wording.register.text_6"
          />
        </div>
      </div>
      <!-- <template v-if="screen === 'register'">
        <div class="password-requirements has-text-right">
          <p class="is-marginless">
            <a
              @click.prevent="showPasswordRequirements"
            >Password requirements</a>
          </p>
        </div>
        <div class="field is-grouped">
          <div class="control is-expanded">
            <input-text-with-validation
              id="password"
              v-model="form.password"
              name="password"
              type="password"
              placeholder="Password"
              rules="required"
              autocomplete="off"
              minlength="8"
              required
            />
          </div>
          <div class="control is-expanded">
            <input-text-with-validation
              id="passwordConfirm"
              v-model="form.confirmPassword"
              name="passwordConfirm"
              type="password"
              rules="required|confirmed:password"
              :placeholder="$wording.register.text_7"
              autocomplete="off"
              required
            />
          </div>
        </div>
      </template> -->
      <hr>
      <div class="content">
        <h4
          class="is-size-6 has-text-weight-semibold"
          v-text="$wording.register.title_2"
        />
        <p>The Lead and Healthy Homes Program will send disclosure and certification information to this address. This section is required.</p>
      </div>
      <div class="field">
        <div class="control">
          <input-text-with-validation
            v-model="form.streetAddress1"
            rules="required"
            name="address"
            :placeholder="$wording.register.text_8"
            required
          />
        </div>
      </div>
      <div class="field">
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.streetAddress2"
            name="address2"
            :placeholder="$wording.register.text_9"
          />
        </div>
      </div>
      <div class="field is-grouped field-grouped-half-fix">
        <div class="control is-expanded">
          <dropdown-with-validation
            v-model="form.country"
            :default-option="`Country`"
            :options="$store.state.countries"
            text-key="name"
            value-key="code"
            rules="required"
            name="country"
            placeholder="Country"
            required
          />
        </div>
        <div class="control is-expanded">
          <dropdown-with-validation
            v-if="form.country === 'USA'"
            v-model="form.state"
            :default-option="$wording.register.text_10"
            :options="$store.state.states"
            rules="required"
            name="state/region"
            :placeholder="$wording.register.text_10"
            required
          />
          <input-text-with-validation
            v-else
            v-model="form.state"
            rules="required"
            name="state"
            :placeholder="$wording.register.text_10"
            required
          />
        </div>
      </div>
      <div class="field is-grouped field-grouped-half-fix">
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.city"
            rules="required"
            name="city"
            placeholder="City"
            required
          />
        </div>
        <div class="control is-expanded">
          <input-text-with-validation
            v-model="form.zip"
            rules="required"
            name="zip"
            :placeholder="$wording.register.text_11"
            required
          />
        </div>
      </div>
      <div
        class="field"
      >
        <div class="control">
          <checkbox-with-validation
            v-model="form.agreedToTermsAndConditions"
            placeholder="Terms and Conditions"
            name="agreedToTermsAndConditions"
            :value="true"
            required
          >
            I agree to the
            <a
              @click.prevent="showTermsAndConditions"
            >Terms and Conditions</a>
          </checkbox-with-validation>
        </div>
      </div>
      <div
        v-if="updated"
        class="notification is-success has-icon"
      >
        <button
          type="button"
          class="delete"
          @click.prevent="updated=false"
        >
          Close
        </button>
        <p>
          <span class="icon">
            <i class="fas fa-check-circle" />
          </span>
          Your profile has been updated. <span v-if="updated==='first'">You may now continue to the application.</span>
        </p>
      </div>
      <div class="field">
        <div class="control has-text-centered">
          <button
            v-show="updated !== 'first'"
            class="button is-primary btn-submit"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading"
            @click.prevent="submit"
          >
            Submit
          </button>
          <router-link
            v-show="updated === 'first'"
            tag="button"
            class="button is-primary"
            :to="{ name: 'home' }"
          >
            Continue
          </router-link>
        </div>
      </div>
    </validation-observer>
    <!-- <template v-if="screen !== 'register'">
      <validation-observer
        id="update-password"
        ref="update-password"
        tag="form"
        @submit.prevent
      >
        <hr>
        <div class="content">
          <h4
            class=""
            v-text="$wording.register.title_1"
          />
        </div>
        <div class="field">
          <div class="control is-expanded">
            <input-text-with-validation
              id="current_password"
              v-model="form.password"
              name="currentPassword"
              type="password"
              data-vv-as="current password"
              placeholder="Current password"
              rules="required"
              autocomplete="off"
              minlength="8"
            />
          </div>
        </div>
        <div class="password-requirements has-text-right">
          <p class="is-marginless">
            <a
              @click.prevent="showPasswordRequirements"
            >Password requirements</a>
          </p>
        </div>
        <div class="field is-grouped">
          <div class="control is-expanded">
            <input-text-with-validation
              id="password"
              v-model="newPassword"
              name="password"
              type="password"
              data-vv-as="password"
              placeholder="Password"
              rules="required"
              autocomplete="off"
              minlength="8"
            />
          </div>
          <div class="control is-expanded">
            <input-text-with-validation
              id="passwordConfirm"
              v-model="confirmNewPassword"
              name="passwordConfirm"
              type="password"
              rules="required|confirmed:password"
              data-vv-as="password confirmation"
              placeholder="Re-enter password"
              autocomplete="off"
            />
          </div>
        </div>

        <div class="field">
          <div class="control has-text-centered">
            <button
              class="button is-primary btn-submit-2"
              :class="{ 'is-loading': isLoadingUpdatePassword }"
              :disabled="isLoadingUpdatePassword"
              @click.prevent="updatePassword"
            >
              Update
            </button>
          </div>
        </div>
      </validation-observer>
    </template> -->
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import CheckboxWithValidation from "@/components/common/CheckboxWithValidation";
import InputTextWithValidation from "@/components/common/InputTextWithValidation";
import DropdownWithValidation from "@/components/common/DropdownWithValidation";
export default {
  components: {
    InputTextWithValidation,
    CheckboxWithValidation,
    DropdownWithValidation,
  },
  props: {
    screen: {
      type: String,
      default: 'register',
    },

    // Property to autopopulate some user info
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      updated: false,
      doingAjax: false,
      updatingPassword: false,
      form: {
        password: '',
        confirmPassword: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: 'PA',
        country: 'USA',
        zip: '',
        phoneNumber: '',
        companyName: '',
        jobTitle: '',
        contactPreference: '',
        agreedToTermsAndConditions: null,
      },
      emailFromToken: '',
      newPassword: '',
      confirmNewPassword: '',

      initialCountry: null,
    };
  },
  computed: {
    isLoading() {
      return this.doingAjax || (!this.user.firstName && this.screen === 'profile');
    },
    isLoadingUpdatePassword() {
      return this.updatingPassword || (!this.user.firstName && this.screen === 'profile');
    },
    selectedCountry() {
      return this.form.country;
    },
  },
  watch: {
    selectedCountry(country) {
      if (country !== this.initialCountry) {
        this.form.state = '';
      }
    },
    user() {
      this.prepopulateForm();
    },
  },
  beforeMount() {
    this.prepopulateForm();

    try {
      const parsedToken = jwt_decode(this.$store.getters['auth/token']);
      this.emailFromToken = parsedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'];
    } catch (err) {
      console.warn("Couldn't parse the token: ", err);
    }
  },
  created() {
    this.$store.dispatch('phillyAccount/handleRedirect');
  },
  methods: {
    prepopulateForm() {
      this.initialCountry = this.user.country;
      this.$set(this, 'form', { ...this.form, ...this.user });
    },

    reset() {
      this.$refs['register-form'].reset();
      Object.assign(this.$data, this.$options.data.apply(this));
    },

    async submit() {
      if (this.doingAjax) {
        return false;
      } 

      const valid = await this.$refs['register-form'].validate();
      if (!valid) {
        return false;
      }
      
      if (this.screen === 'register') {
        this.doingAjax = true;
        const saved = await this.$store.dispatch('users/registerUser', this.form);
        this.doingAjax = false;

        if (saved) {
          this.$sCache.set('register-email', this.form.email);
          this.reset();

          this.$router.push({ name: 'register-success' });
        }
      } else {
        // These values has to be null
        this.form.email = null;
        this.form.password = null;
        this.form.confirmPassword = null;

        this.doingAjax = true;
        this.updated = await this.$store.dispatch('users/updateUser', this.form);
        this.doingAjax = false;
      }
    },

    async updatePassword() {
      const valid = await this.$refs['update-password'].validate();
      if (!valid) {
        return false;
      }

      this.updatingPassword = true;
      const formData = {
        currentPassword: this.form.password,
        password: this.newPassword,
      };

      const response = await this.$store.dispatch('users/updatePassword', formData);
      if (response) {
        this.$refs['update-password'].reset();
        this.form.password = '';
        this.newPassword = '';
        this.confirmNewPassword = '';
      }
      this.updatingPassword = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .password-requirements {
    p {
      font-size: 0.875rem;
      a {
        font-weight: $weight-normal;
      }
    }
  }
  .middle-name {
    max-width: calc(100% / 3);
  }
</style>